import { render, staticRenderFns } from "./sizes.vue?vue&type=template&id=155e2308"
import script from "./sizes.vue?vue&type=script&lang=js"
export * from "./sizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports